module.exports = __webpack_public_path__ + "e28863bda036bf979cbe18223b5f8dfb.pdf";